'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, Sparkles, X } from 'lucide-react';
import { cn } from '~/utils';
import { useI18n } from '~/features/i18n';

/**
 * Shared header for the AI chat surface (desktop sidebar + mobile drawer).
 *
 * Empty state: Sparkles icon + "AI search" title.
 * Active thread: "← All chats" back button + the thread's title (no Sparkles,
 * no "AI search" label — the title takes over).
 *
 * The optional close button (`onClose`) is rendered on the right when provided.
 */
export const ActivityAiChatHeader: React.FC<{
  hasActiveThread: boolean;
  threadTitle?: string;
  onBack: () => void;
  onClose?: () => void;
  className?: string;
}> = t0 => {
  const $ = _c(14);
  const {
    hasActiveThread,
    threadTitle,
    onBack,
    onClose,
    className
  } = t0;
  const i18n = useI18n();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex shrink-0 items-center gap-2 px-6 pb-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasActiveThread || $[3] !== i18n || $[4] !== onBack || $[5] !== threadTitle) {
    t2 = hasActiveThread ? <><button type="button" onClick={onBack} data-testid="ai-chat-back" aria-label={i18n._("activity.search.ai.backToChats", undefined, {
        message: "All chats"
      })} className="-ml-2 inline-flex shrink-0 items-center gap-1.5 rounded-full px-2 py-1 text-sm font-medium text-blue-900/80 transition-colors hover:bg-blue-50 hover:text-blue-900"><ArrowLeft className="size-4" strokeWidth={2.25} aria-hidden={true} />{i18n._("activity.search.ai.backToChats", undefined, {
          message: "All chats"
        })}</button><p className="flex-1 truncate text-base font-semibold leading-tight text-blue-900">{threadTitle && threadTitle.length > 0 ? threadTitle : i18n._("activity.search.ai.untitledChat", undefined, {
          message: "New chat"
        })}</p></> : <><Sparkles className="size-5 shrink-0 text-primary" strokeWidth={2.25} aria-hidden={true} /><p className="flex-1 text-base font-semibold leading-tight text-blue-900">{i18n._("activity.search.ai.sidebarTitle", undefined, {
          message: "AI search"
        })}</p></>;
    $[2] = hasActiveThread;
    $[3] = i18n;
    $[4] = onBack;
    $[5] = threadTitle;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== i18n || $[8] !== onClose) {
    t3 = onClose ? <button type="button" onClick={onClose} aria-label={i18n._("activity.search.ai.close", undefined, {
      message: "Close"
    })} className="-mr-1 shrink-0 rounded-full p-1 text-blue-400 transition-colors hover:bg-blue-50 hover:text-blue-900"><X className="size-4" strokeWidth={2.25} aria-hidden={true} /></button> : null;
    $[7] = i18n;
    $[8] = onClose;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};